import {
  ChangeDetectorRef,
  Directive,
  effect,
  input,
  inject,
} from '@angular/core';
import { Divider } from 'primeng/divider';
import { DividerColor } from '../types/divider-color';
import { isNotNil } from '@web/utils';

@Directive({
  selector: '[appPrimengDivider]',
  standalone: true,
})
export class PrimengDividerDirective {
  private readonly divider = inject(Divider);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly color = input<DividerColor>('primary');

  private readonly initialStyleClass = this.getStyleClass();

  public constructor() {
    effect(() => this.configureStyleClass());
  }

  private configureStyleClass(): void {
    const styles = [...this.initialStyleClass, ...this.getColorStyleClass()];

    this.divider.styleClass = styles.filter(isNotNil).join(' ');
    this.changeDetectorRef.detectChanges();
  }

  private getColorStyleClass(): string[] {
    return [];
  }

  private getStyleClass(): string[] {
    return this.divider.styleClass?.split(' ') ?? [];
  }
}
